import { authenticationService } from "@/services/AuthenticationService";

export const getValueFromGlobalOptions = (globalOptions, key) => {
  if (Array.isArray(globalOptions)) {
    let obj = globalOptions.find(x => x.go_key === key);

    if (obj) {
      return obj["go_value"];
    }
  }

  return null;
};

export const validateShowCinema = (cinema_id) => {
  console.log('VALIDATING CINEMA...', cinema_id, authenticationService.get("USINFO").cinema_id);
  let loggedCinemaId = window.localStorage.getItem('cinema_id')
  let status = true;
  if(cinema_id && loggedCinemaId) {
    if(cinema_id == authenticationService.get("USINFO").cinema_id && loggedCinemaId == cinema_id) {
      status = true;
    } else {
      status = false;
    }
  } else {
    status = false;
  }
  console.log('VALIDATE CINEMA STATUS', status);
  return status;
};


// WEBPACK FOOTER //
// ./src/helper/utils.js